import React, {useEffect, useState} from 'react';
import './Layout.css';
import {Translation, withTranslation, WithTranslation} from 'react-i18next';
import {NavLink, useLocation} from "react-router-dom";
import {getApi, getAuthClientId, getAuthUrl} from "./api/Api";
import {PageDescription} from "./model/Page";
import {AuthState} from "./model/AuthState";
import {useAuth} from "./service/AuthProvider";

const Layout = (props: Props) => {
    document.title = props.t("description.title") + " - " + props.t("zavediaev")
    const [pageDescriptionsLoading, setPageDescriptionsLoading] = useState(true)
    const [pageDescriptions, setPageDescriptions] = useState([] as PageDescription[])

    const {user, login, logout, getAccessToken} = useAuth();
    const [authState, setAuthState] = useState<AuthState>({
        redirectAfterAuthUrl: window.location.href.replace(window.location.origin, ""),
        loggingIn: false,
    });

    const api = getApi() // todo make provider and add to dependencies of useEffect
    const location = useLocation();

    useEffect(() => {
        getApi().getPageDescriptions().then((pageDescriptions) => {
            setPageDescriptions(pageDescriptions)
            setPageDescriptionsLoading(false)
        })
    }, [getAccessToken])

    useEffect(() => {
        const newAuthState = {
            redirectAfterAuthUrl: window.location.href.replace(window.location.origin, ""),
            loggingIn: !user
        }
        setAuthState(newAuthState)
    }, [user, setAuthState, location])

    return (
        <Translation>{t =>
            <div>
                <nav className="navbar navbar-expand-lg bg-body-tertiary bg-light">
                    <div className="container-xxl">
                        <NavLink className="navbar-brand" to="/">
                            <img src={process.env.PUBLIC_URL + '/favicon.png'} alt="Logo" width="24" height="24"
                                 className="d-inline-block align-text-top"/>
                            &nbsp;{t('zavediaev')}
                        </NavLink>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                                data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup"
                                aria-expanded="false"
                                aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                            <div className="navbar-nav me-auto">
                                {pageDescriptionsLoading ? (
                                    <span>Loading...</span>) : pageDescriptions.map(pageDescription => (
                                    <NavLink key={pageDescription.id} className="nav-link"
                                             to={"/page/" + pageDescription.id}>{pageDescription.title}</NavLink>
                                ))}
                            </div>
                            <div className="navbar-nav">
                                {

                                    user ? (
                                        <a className="nav-link"
                                           href={`${getAuthUrl()}/logout?client_id=${getAuthClientId()}&logout_uri=${encodeURIComponent(`${window.location.origin}/auth/callback`)}`}>Logout</a>
                                    ) : (
                                        <a className="nav-link"
                                           href={`${getAuthUrl()}/login?client_id=${getAuthClientId()}&response_type=code&scope=email+openid+phone&redirect_uri=${encodeURIComponent(`${window.location.origin}/auth/callback`)}&state=${encodeURIComponent(JSON.stringify(authState))}`}>Login</a>
                                    )}
                            </div>
                        </div>
                    </div>
                </nav>
                {props.children}
            </div>
        }</Translation>
    )
}

interface Props extends WithTranslation {
    children?: React.ReactNode
}

export default withTranslation()(Layout)
